import Box from "@mui/material/Box";
import { Typography } from "@mui/material";

// components
import { AdminPerfomance } from "./admin-perfomance";
import { Chart } from "./pie-chart";
import { ChartPercentage } from "./chart-percentage";
import { formatArea, formatCost } from "../../../utils/formatting";
import { TooltipWithIconCustom } from "../../ui/tooltip-custom";
import { TEXT } from "../../../constants/text";
import { useUserContext } from "../../../services/context/user-context";
import { ResultRating } from "./result-rating";

// svg
import { ReactComponent as IconBuildingsArea } from "../../../assets/svg/kpi-building-area.svg";
import { ReactComponent as IconTotalBuiltArea } from "../../../assets/svg/totalbuilt-area.svg";
import { ReactComponent as IconFreeArea } from "../../../assets/svg/free-area-2.svg";
import { ReactComponent as IconChartPie } from "../../../assets/svg/chart-pie-2.svg";
import { ReactComponent as IconCost } from "../../../assets/svg/cost-3.svg";

//style
import "./sidebar-results.css";


export const TabPerfomance = ({ selectedResult, propertyArea, isSurvey }) => {
  const { userData } = useUserContext();

  const kpis = [
    {
      id: "kpi-1",
      name: TEXT.sidebarResults.kpis.totalBuiltUpAreaTitle,
      unit: formatArea(selectedResult?.kpis?.totalBuiltUpArea)?.unit,
      value: formatArea(selectedResult?.kpis?.totalBuiltUpArea)?.value,
      icon: "total_build_area",
      tooltip: TEXT.sidebarResults.kpis.totalBuiltUpAreaTooltip,
    },
    {
      id: "kpi-2",
      name: TEXT.sidebarResults.kpis.totalBuildingAreaTitle,
      unit: formatArea(selectedResult?.kpis?.buildingArea)?.unit,
      value: formatArea(selectedResult?.kpis?.buildingArea)?.value,
      icon: "building_area",
      tooltip: TEXT.sidebarResults.kpis.totalBuildingAreaTooltip,
    },
    {
      id: "kpi-3",
      name: TEXT.sidebarResults.kpis.greenAreaTitle,
      unit: formatArea(selectedResult?.kpis?.freeArea)?.unit,
      value: formatArea(selectedResult?.kpis?.freeArea)?.value,
      icon: "free_area",
      tooltip: TEXT.sidebarResults.kpis.greenAreaTooltip,
    },
    {
      id: "kpi-4",
      name: TEXT.sidebarResults.kpis.totalCostTitle,
      unit: "€",
      value: formatCost(selectedResult?.kpis?.totalCost)?.value,
      icon: "cost",
      tooltip: TEXT.sidebarResults.kpis.totalCostTooltip,
    },
  ];

  const freeAreaPercentage =
    propertyArea && selectedResult.kpis.freeArea
      ? ((selectedResult.kpis.freeArea / propertyArea) * 100).toFixed(0)
      : null;

  const icons = {
    total_build_area: (
      <IconTotalBuiltArea fill="#343745" width="16px" height="16px" />
    ),
    building_area: (
      <IconBuildingsArea fill="#343745" width="16px" height="16px" />
    ),
    free_area: <IconFreeArea fill="#343745" width="16px" height="16px" />,
    cost: <IconCost fill="#343745" width="16px" height="18px" />,
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "22px",
        width: "100%",
        p: "16px",
      }}
    >
      {kpis.map((kpi) =>
        kpi.value && kpi.value !== -1 ? (
          <Box
            key={kpi.id}
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "4px",
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                width: "100%",
              }}
            >
              {icons[kpi.icon]}
              <TooltipWithIconCustom text={kpi.tooltip}>
                <Typography color="#343745" fontSize="14px" fontWeight={700}>
                  {kpi.name}
                </Typography>
              </TooltipWithIconCustom>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                width: "100%",
              }}
            >
              <Typography color="#5D5F6A" fontSize={"16px"}>
                {kpi.value} <span style={{ fontSize: "12px" }}>{kpi.unit}</span>
              </Typography>
              {kpi.id === "kpi-3" && freeAreaPercentage && (
                <ChartPercentage value={freeAreaPercentage} />
              )}
            </Box>
          </Box>
        ) : null
      )}

      {selectedResult?.kpis?.areaBalance && (
        <>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              width: "100%",
            }}
          >
            <Box><IconChartPie fill="#343745" width="16px" height="16px" /></Box>
            <TooltipWithIconCustom
              text={TEXT.sidebarResults.kpis.areaBalanceTooltip}
            >
              <Typography color="#343745" fontSize="14px" fontWeight={700} >
                {TEXT.sidebarResults.kpis.areaBalanceTitle}
              </Typography>
            </TooltipWithIconCustom>
          </Box>

          <Chart areaBalance={selectedResult.kpis.areaBalance} isSurvey={isSurvey} />
        </>
      )}

      <ResultRating resultId={selectedResult.resultId} /* resultRating={selectedResult.rating} *//>

      {userData.isAdmin && (
        <Box mt="16px">
          <AdminPerfomance selectedResult={selectedResult} />
        </Box>
      )}
    </Box>
  );
};
